import React, { Component } from "react"
import OutsideClickTrigger from "./OutsideClickTrigger"

class SpinnerModal extends Component {
  render() {
    return (
      <div className="overlay overlay--modal overlay--fixed is-active">
        <div className="modal">
          {this.props.isSpinnerActive ? (
            <React.Fragment>
              <button className="button button--icon js--close-modal">
                <span className="icon">
                  <svg className="svg-icon svg-icon--close-new">
                    <use xmlnsXlink="http://www.w3.org/1999/xlink" xlinkHref="/dist/svg/symbols.svg#svg-close-new">
                      &nbsp;
                    </use>
                  </svg>
                </span>
              </button>
              <div className="modal__content">
                <div className="modal__content__inner">
                  {this.props.genericModalTop ? (
                    <div className="modal__top" dangerouslySetInnerHTML={{ __html: this.props.genericModalTop }}>
                      {" "}
                    </div>
                  ) : (
                    ""
                  )}
                  {this.props.genericModalBody ? (
                    <div className="modal__middle rich-text" dangerouslySetInnerHTML={{ __html: this.props.genericModalBody }}></div>
                  ) : (
                    ""
                  )}
                  {this.props.genericModalBottom ? (
                    <div className="modal__bottom" dangerouslySetInnerHTML={{ __html: this.props.genericModalBottom }}></div>
                  ) : (
                    ""
                  )}
                  <div className="modal__bottom">
                    <div className="is-active">
                      <span className="spinner"></span>
                    </div>
                  </div>
                </div>
              </div>
            </React.Fragment>
          ) : (
            <OutsideClickTrigger onOutsideClick={this.props.genericModalClose}>
              <button className="button button--icon js--close-modal" onClick={this.props.genericModalClose}>
                <span className="icon">
                  <svg className="svg-icon svg-icon--close-new">
                    <use xmlnsXlink="http://www.w3.org/1999/xlink" xlinkHref="/dist/svg/symbols.svg#svg-close-new">
                      &nbsp;
                    </use>
                  </svg>
                </span>
              </button>
              <div className="modal__content">
                <div className="modal__content__inner">
                  {this.props.genericModalTop ? (
                    <div className="modal__top" dangerouslySetInnerHTML={{ __html: this.props.genericModalTop }}>
                      {" "}
                    </div>
                  ) : (
                    ""
                  )}
                  {this.props.genericModalBody ? (
                    <div className="modal__middle rich-text" dangerouslySetInnerHTML={{ __html: this.props.genericModalBody }}></div>
                  ) : (
                    ""
                  )}
                  {this.props.genericModalBottom ? (
                    <div className="modal__bottom" dangerouslySetInnerHTML={{ __html: this.props.genericModalBottom }}></div>
                  ) : (
                    ""
                  )}
                </div>
              </div>
            </OutsideClickTrigger>
          )}
        </div>
      </div>
    )
  }
}

export default SpinnerModal
